import script from "./batchOrderAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./batchOrderAccount.vue?vue&type=script&setup=true&lang=js"

import "./batchOrderAccount.vue?vue&type=style&index=0&id=2b0763ee&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0763ee"]])

export default __exports__